import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

import { SnShare } from '@lib/api/entities';

@Component({
  selector: 'sn-share-details-v2',
  templateUrl: './share-details-v2.component.html',
  styleUrls: ['./share-details-v2.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ShareDetailsV2Component {
  @Input()
  public share?: SnShare;

}

